import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useEffect, useRef } from "react";
import { useQuery } from "react-query";

import { useOpenChatRoomUuid } from "./useOpenChatRoomUuid";

interface Props {
  command: (item: any) => void;
  href: string;
}

interface UnfurlMessageLink {
  is_private_message?: boolean;
  sgid: string;
  type: string;
}

export const ChatMessagePaste = ({ href, command }: Props): any => {
  const { addToLocalSgidToObjectMap } = useTipTapEditorContext();
  const { chatRoomUuid } = useOpenChatRoomUuid();

  const processedSgidRef = useRef<string | null>(null);
  const { data = [] } = useQuery<UnfurlMessageLink[]>({
    queryKey: [
      internalApi.richTextFields.unfurlURLs({
        params: { urls: [href], open_chat_room_uuid: chatRoomUuid },
      }),
    ],
    initialData: [],
  });

  useEffect(() => {
    const chatMessageLink = data[0];

    if (!chatMessageLink?.type) return;
    if (processedSgidRef.current === chatMessageLink.sgid) return;

    let isCancelled = false;

    queueMicrotask(() => {
      if (isCancelled) return;

      processedSgidRef.current = chatMessageLink.sgid;
      addToLocalSgidToObjectMap({
        sgid: chatMessageLink.sgid,
        object: chatMessageLink,
      });
      command(chatMessageLink.sgid);
    });

    return () => {
      isCancelled = true;
    };
  }, [addToLocalSgidToObjectMap, command, data]);

  return null;
};

ChatMessagePaste.displayName = "ChatMessagePaste";
